import { Feed } from './Feed';

export class Job extends Feed {
    other_info: string;
    logo:string;
    package:any;
    location:string;
    experience: any;
    skills_required:string[];
    apply_start_date:number;
    apply_end_date;number;
    tenure:any;
    total_vacancy:number;
    company_name:string;
    available_vacancy:number;
}
